import { gql, useMutation } from '@apollo/client';

import { useMyUser } from '@providers/User';
import { useBookForMeetingRooms } from '@views/Book/Book/BasicBook/Booking/hooks';
import { useHasFeature } from '@views/shared/hooks/hasFeature';
import {
  BookingWithArea,
  BookingHooksBasicProps,
  CreateBookingAreaResponse,
} from '@views/shared/interfaces/booking';

const createBookingMutation = gql`
  mutation bookMeetingRoom(
    $areaId: ID!
    $start: DateTime!
    $end: DateTime!
    $comment: String
  ) {
    createBooking(
      booking: { areaId: $areaId, start: $start, end: $end, comment: $comment }
    ) {
      id
      start
      end
      area {
        areaType
        name
        floor {
          floorLabel
          floorNumber
          floorType
          building {
            name
            address
          }
        }
      }
      comment
    }
  }
`;

export function useBook({
  date,
  enabledHalfDayBooking,
  enabledHourlyBooking,
  hasNextDaysBooking,
  formats,
  params: { areaId },
  t,
  type,
}: BookingHooksBasicProps) {
  const {
    permissions: { canBookCatering, canBookEquipment },
  } = useMyUser();
  const enabledCateringBooking = useHasFeature('booking_catering');
  const enabledEquippingBooking = useHasFeature('booking_equipping');

  const mutation = useMutation<
    { createBooking: CreateBookingAreaResponse },
    BookingWithArea
  >(createBookingMutation, {});

  return useBookForMeetingRooms({
    date,
    enabledHalfDayBooking,
    enabledHourlyBooking,
    hasNextDaysBooking,
    t,
    type,
    params: {
      areaId,
      enabledCateringBooking: enabledCateringBooking && canBookCatering,
      enabledEquippingBooking: enabledEquippingBooking && canBookEquipment,
    },
    formats,
    bookingMutation: mutation,
  });
}
